module.exports = {
      id: "epaper-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#epaper",
      toString: function () {
        return this.url;
      }
    }